// extracted by mini-css-extract-plugin
module.exports = {"indicator":"Indicator_indicator__BbV3D"};